<template>
    <b-input-group
        :size="size"
        class="school-year-yate-input d-flex flex-nowrap"
    >
        <b-select :options="months" v-model="selectedMonth"></b-select>
        <b-input-group-append is-text>
            <span>{{ year }}</span>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
import SingPause from "@/mixins/SingPause/SingPause";

export default {
    name: "SchoolYearDateInput",
    mixins: [],
    props: ["size", "school_year", "value"],
    data() {
        return {
            selectedMonth: this.parseMonth(this.value)
        };
    },
    computed: {
        year() {
            if (this.selectedMonth) {
                return this.determineYearWithinSchoolYear(
                    this.school_year,
                    this.selectedMonth
                );
            } else {
                return this.selectedYear;
            }
        },
        months() {
            var start = 1;
            const end = 12;
            var months = [];
            while (start <= end) {
                months.push({ text: start, value: start });
                start += 1;
            }
            return months;
        },
        date() {
            const date = this.$moment(
                this.year + "-" + this.selectedMonth + "-01"
            ).format("Y-MM-DD");
            return date;
        }
    },
    watch: {
        selectedMonth: {
            handler(val) {
                this.$emit("input", this.date);
            },
            immediate: true
        },
        school_year: {
            handler(val) {
                this.$emit("input", this.date);
            }
        }
    },
    methods: {
        determineYearWithinSchoolYear(school_year, month) {
            if (month >= 9) {
                return school_year;
            } else {
                return parseInt(school_year) + 1;
            }
        },
        parseMonth(date) {
            if (date) {
                return this.$moment(date).format("M");
            } else {
                return this.$moment().format("M");
            }
        }
    }
};
</script>
